import {
  FETCH_PERMISSIONS,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAILURE,
  PermissionsState,
} from "./types";

const initialState: PermissionsState = {
  agentStudio: {
    grantedPermissions: [],
    isLoading: false,
    error: null,
  },
};

export const permissionsReducer = (state = initialState, action: any): PermissionsState => {
  switch (action.type) {
    case FETCH_PERMISSIONS:
      return {
        ...state,
        agentStudio: {
          ...state.agentStudio,
          isLoading: true,
          error: null,
        },
      };
    case FETCH_PERMISSIONS_SUCCESS:
      return {
        ...state,
        agentStudio: {
          grantedPermissions: action.payload.agentStudio.grantedPermissions,
          isLoading: false,
          error: null,
        },
      };
    case FETCH_PERMISSIONS_FAILURE:
      return {
        ...state,
        agentStudio: {
          grantedPermissions: [],
          isLoading: false,
          error: action.payload.error,
        },
      };
    default:
      return state;
  }
};
